import { render, staticRenderFns } from "./viewExamcodeLook.vue?vue&type=template&id=3b8e63b9&scoped=true&"
import script from "./viewExamcodeLook.vue?vue&type=script&lang=js&"
export * from "./viewExamcodeLook.vue?vue&type=script&lang=js&"
import style0 from "./viewExamcodeLook.vue?vue&type=style&index=0&id=3b8e63b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e63b9",
  null
  
)

export default component.exports